module.exports = __webpack_public_path__ + "15088a7c624d9857c7aea2befeda1811.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/proximanova-regular-webfont.ttf
// module id = 312
// module chunks = 0